import React from 'react';
import { ArrowLeftRight } from 'lucide-react';
import { Card } from './ui/card';

const ScellantBeforeAfter = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 to-black border-b border-red-500/20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-red-900/30 border border-red-500/30 rounded-full px-4 py-2 mb-4">
            <ArrowLeftRight size={18} className="text-red-500" />
            <span className="text-sm font-semibold text-white">Transformation</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="text-white">Avant</span>
            {' '}
            <span className="text-red-500">/</span>
            {' '}
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              Après
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Découvrez la différence spectaculaire de notre travail
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <Card className="relative overflow-hidden border border-red-500/30 bg-gray-900 shadow-2xl">
            <div className="relative">
              {/* Image Before/After */}
              <img
                src="https://customer-assets.emergentagent.com/job_sealwash/artifacts/sryahy8x_Screenshot%202026-02-09%20085851.png"
                alt="Avant et Après - Scellant d'asphalte"
                className="w-full h-auto object-cover"
              />
              
              {/* Labels */}
              <div className="absolute top-4 left-4 bg-gray-700/90 backdrop-blur-sm text-white px-6 py-3 rounded-lg font-bold text-lg shadow-xl border-2 border-gray-500">
                AVANT
              </div>
              <div className="absolute top-4 right-4 bg-red-600/90 backdrop-blur-sm text-white px-6 py-3 rounded-lg font-bold text-lg shadow-xl border-2 border-red-500">
                APRÈS
              </div>

              {/* Divider Line in Middle */}
              <div className="absolute top-0 bottom-0 left-1/2 w-1 bg-white shadow-2xl transform -translate-x-1/2"></div>
            </div>
          </Card>

          {/* Info Text */}
          <div className="mt-8 text-center">
            <p className="text-gray-300 mb-2">
              <span className="text-red-500 font-semibold">Surface ravivée</span> et protégée avec notre bitume de qualité supérieure
            </p>
            <p className="text-sm text-gray-500">
              Résultat professionnel garanti
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScellantBeforeAfter;
